<template>
  <el-card class="box-card mb-50" id="contactSendMail">
    <el-row>
      <el-col :span="24">
        <el-form :rules="rules" :model="inputForm" ref="inputForm" id="form" :action="urls.change" method="post">
          <div class="group-input mt-0"><span>{{ pageCheck === 'changeMail' ? $t('change_mail.send.group_current_input') : $t('contacts.mail.send.group_current_input') }}</span></div>
          <p v-if="pageCheck === 'changeMail'" class="desc">{{ $t('change_mail.send.desc') }}</p>
          <el-form-item prop="mail_address" :error="getErrorForField('mail_address', errors)">
            <el-input :placeholder="pageCheck === 'changeMail' ? $t('change_mail.send.placeholder') : $t('contacts.mail.send.placeholder')" v-model="inputForm.mail_address" name="mail_address" :type="typeInput"/>
          </el-form-item>
          <input type="hidden" name="_token" :value="csrf">
          <div class="form-footer">
            <el-button class="btn-reset" @click="reset('inputForm')">{{ pageCheck === 'changeMail' ? $t('change_mail.send.btn') : $t('contacts.mail.send.btn') }}</el-button>
          </div>
        </el-form>
       </el-col>
    </el-row>
  </el-card>
</template>
<script>
  export default {
    props: {
      errors: { type: Object, required: false },
      urls: { type: Object, required: false, default: {} },
      role: { type: Number, required: false, default: 3 },
      pageCheck: { type: String, default: '' },
    },
    data() {
      const validateMailAddress = (rule, value, callback) => {
          var regex = /\S+@\S+\.\S+/
          if (!regex.test(value)) {
              callback(new Error(this.$t('errors.email', [this.$t('mail_address')])))
          } else {
              callback()
          }
      }
      return {
        inputForm: {
          mail_address: "",
        },
        rules: {
          mail_address: [
            { required: true, message: this.$t('errors.required', [this.$t('mail_address')]), trigger: 'blur' },
            { max: 255, message: this.$t('errors.max', [this.$t('mail_address'), 255]), trigger: 'blur' },
            { validator: validateMailAddress, trigger: 'blur' },
          ],
        },
        csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      }
    },
    methods: {
      reset(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            const form = document.getElementById("form");
            form.submit();
          } else {
            return false;
          }
        });
      },

      isErrorForField(field, errors) {
        return !(errors == null || errors.length == 0 || !errors.hasOwnProperty(field));
      },

      getErrorForField(field, errors) {
        return this.isErrorForField(field, errors) ? errors[field][0] : '';
      },
    },
  }
</script>

<style lang="scss">
  #contactSendMail {
    min-height: 560px;
    .el-form {
      width: 100%;
      .el-input {
        width: 454px;
        height: 45px;
      }
      .el-form-item__content {
        margin-top: 20px;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
      }
      .el-form-item__label {
        width: 100%;
        text-align: left;
        font: normal normal normal 13px/29px Kozuka Gothic Pr6N;
        letter-spacing: 1.3px;
        color: #000000;
        justify-content: flex-start;
        font-weight: 700;
      }
      .text-danger {
        white-space: pre-line;
        color: #AC3B29;
        font-size: 13px;
        letter-spacing: 1.3px;
        line-height: 21px;
        margin-bottom: 8px;
      }
    }
    .desc {
      white-space: pre-line;
      font-size: 13px;
      letter-spacing: 1.3px;
      line-height: 29px;
      margin-bottom: 0;
    }
  }
</style>
